import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { colors, fonts } from "../../assets/styles/theme.ts";
import styled from "styled-components";
interface Props {
  img?: string;
  alt?: string;
  className?: string;
  width?: string;
  height?: string;
  material?: React.ReactNode;
  onClick?: () => void;
  label?: any;
  tooltip: boolean
}

const RenderImg: React.FC<Props> = ({
  img,
  alt,
  material,
  className,
  width,
  height,
  onClick,
  label,
  tooltip,
}: Props) => {
  if (material) return <>{material}</>;

  const content = (
    <>
      <img
        src={img}
        alt={alt}
        className={className}
        width={width}
        height={height}
        onClick={onClick}
      />
      {label && <StyledTypography>{label}</StyledTypography>}
    </>
  );

  const wrappedContent = tooltip ? <Tooltip title={tooltip}><span>{content}</span></Tooltip> : content;

  return label ? <Box sx={{ display: "flex" }}>{wrappedContent}</Box> : wrappedContent;
};

export default RenderImg

const StyledTypography = styled(Typography)`
    font-family: ${fonts.primary} !important;
    color: ${colors.blueDark} !important;
    font-weight: 600 !important;
`;